import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {Swiper, SwiperSlide} from 'swiper/react'
import {Autoplay, Navigation, Pagination} from 'swiper/modules'
import Hero from '../hero'

export const HeroSlider = ({regions = [], enableAutoScoll}) => {
    const slideRegion = regions.find((r) => r.id === 'slide')
    const slides =
        slideRegion?.components?.map((comp) => ({
            ...comp?.data,
            regions: comp?.regions
        })) || []
    const [renderAllSlides, setRenderAllSlides] = useState(false)
    const autoScrollProps = enableAutoScoll
        ? {
              autoplay: {
                  delay: 5000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true
              },
              onTouchStart: (swiper) => swiper.autoplay?.stop?.(),
              onTouchEnd: (swiper) => {
                  setTimeout(() => swiper.autoplay?.start?.(), 1500)
              },
              onSlideChange: (swiper) => {
                  setTimeout(() => swiper.autoplay?.start?.(), 1500)
              }
          }
        : {}
    useEffect(() => {
        setTimeout(() => {
            setRenderAllSlides(true)
        }, 400)
    }, [slides?.length])
    if (!slides.length) return null

    return (
        <Box
            w="100%"
            sx={{
                '.swiper-pagination': {
                    bottom: '10px !important',
                    left: '50% !important',
                    transform: 'translateX(-50%) !important',
                    width: 'fit-content !important'
                },
                '.hero-carousel .swiper-button-next, .hero-carousel .swiper-button-prev': {
                    opacity: 0,
                    transition: 'opacity 0.3s ease'
                },
                '.hero-carousel:hover .swiper-button-next, .hero-carousel:hover .swiper-button-prev':
                    {
                        opacity: 1
                    },
                '.hero-carousel .swiper-button-next': {
                    right: '20px',
                    top: '50%',
                    transform: 'translateY(-50%)'
                },
                '.hero-carousel .swiper-button-prev': {
                    left: '20px',
                    top: '50%',
                    transform: 'translateY(-50%) rotate(180deg)'
                },
                '.hero-carousel .swiper-pagination-bullet': {
                    width: '6px',
                    height: '6px',
                    background: 'transparent',
                    border: '1px solid white',
                    borderRadius: '50%',
                    opacity: '1'
                },
                '.hero-carousel .swiper-pagination-bullet-active': {
                    background: 'white',
                    borderColor: 'white'
                },
                '@media screen and (min-width: 1200px)': {
                    '.hero-carousel .swiper-pagination': {
                        display: 'none'
                    }
                },
                '@media screen and (max-width: 1200px)': {
                    '.hero-carousel .swiper-button-next': {
                        display: 'none'
                    },
                    '.hero-carousel .swiper-button-prev': {
                        display: 'none'
                    }
                },
                '.hero-carousel .swiper-slide': {
                    opacity: '0',
                    visibility: 'hidden'
                },
                '.hero-carousel .swiper-slide.swiper-slide-active, .hero-carousel .swiper-slide.swiper-slide-next, .hero-carousel.swiper-slide.swiper-slide-prev':
                    {
                        opacity: '1',
                        visibility: 'visible'
                    }
            }}
        >
            <Swiper
                className="hero-carousel"
                modules={[Autoplay, Navigation, Pagination]}
                loop
                pagination={{clickable: true}}
                navigation
                {...autoScrollProps}
            >
                {(renderAllSlides ? slides : slides?.slice(0, 1))?.map((slideProps, idx) => (
                    <SwiperSlide key={idx}>
                        <Hero {...slideProps} />
                    </SwiperSlide>
                ))}
            </Swiper>
        </Box>
    )
}

HeroSlider.propTypes = {
    regions: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            components: PropTypes.arrayOf(
                PropTypes.shape({
                    data: PropTypes.object.isRequired
                })
            )
        })
    ),
    enableAutoScoll: PropTypes.bool
}

export default HeroSlider
